import { Component } from '@angular/core';
import { OmpSectionSettings } from '..';

@Component({
  selector: 'omp-order-list-settings',
  templateUrl: './order-list-settings.component.html',
  styleUrls: ['../controls/omp-controls.scss'],
})
export class OmpOrderListSettingsComponent extends OmpSectionSettings {}
